import { render } from "./DocumentErrorModal.vue?vue&type=template&id=254242fc&scoped=true"
import script from "./DocumentErrorModal.vue?vue&type=script&lang=js"
export * from "./DocumentErrorModal.vue?vue&type=script&lang=js"

import "../../assets/scss/document_error.scss?vue&type=style&index=0&id=254242fc&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254242fc"]])

export default __exports__